export default "__VITE_ASSET__1PURyS5Bj0RqqbgyOhsYgA__"